import {Numbers} from "../../../../utils/Numbers";
import {FundingTypes} from "./FinalReportFundingTypes";
import {OmitModes} from "./OmitModes";

export const FinalReportCostsUtils = {

	methods: {

		calculateCostsMerged() {
			let result = [];
			for (let action of this.projectData.actions) {

				let mergedCosts = {
					action: action.name,
					serialNumber: action.serialNumber,
					costs: this.costsMergedSingleAction(action)
				};
				this.postprocessCosts(mergedCosts);
				result.push(mergedCosts);
			}

			return result;
		},

		calculateAdministrativeMerged() {

			let costsMerged = {
				costs: this.costsMergedAdministrative()
			};
			this.postprocessCosts(costsMerged);

			return costsMerged;
		},

		percentDotationFromProjectFormatted (omitMode = null, calculateOnOldVersion = false) {
			let dotation = this.sumOfCostsFromTypesFromProject([FundingTypes.DOTATION], omitMode, calculateOnOldVersion);
			let total = this.fromProjectSum(calculateOnOldVersion);
			if (total < 0.01) {
				return "-";
			}
			return (dotation / total * 100).toFixed(2).replace(".", ",");
		},

		percentSumOfCostsToDotationFromDocument (types, omitMode = null, calculateOnOldVersion = false) {
			let res = this.sumOfCostsFromTypesFromDocument(types, omitMode, calculateOnOldVersion);
			let dotation = this.sumOfCostsFromTypesFromDocument([FundingTypes.DOTATION], omitMode, calculateOnOldVersion);
			if (dotation < 0.01) {
				return "-";
			}
			return (res / dotation * 100).toFixed(2).replace(".", ",");
		},

		percentSumOfCostsToDotationFromProject (types, omitMode = null, calculateOnOldVersion = false) {
			let res = this.sumOfCostsFromTypesFromProject(types, omitMode, calculateOnOldVersion);
			let dotation = this.sumOfCostsFromTypesFromProject([FundingTypes.DOTATION], omitMode, calculateOnOldVersion);
			if (dotation < 0.01) {
				return "-";
			}
			return (res / dotation * 100).toFixed(2).replace(".", ",");
		},

		percentDotationFromDocumentFormatted (omitMode = null, calculateOnOldVersion = false) {
			let dotation = this.sumOfCostsFromTypesFromDocument([FundingTypes.DOTATION], omitMode, calculateOnOldVersion);
			let total = this.fromDocumentSum(calculateOnOldVersion);
			if (total < 0.01) {
				return "-";
			}
			return (dotation / total * 100).toFixed(2).replace(".", ",");
		},

		fromProjectSum (calculateOnOldVersion = false) {
			let costs, administrativeCosts;
			if (calculateOnOldVersion) {
				costs = this.previousCostsMerged;
				administrativeCosts = this.previousAdministrativeMerged;
			} else {
				costs = this.costsMerged;
				administrativeCosts = this.administrativeMerged;
			}
			let res = 0;
			res += administrativeCosts.fromProjectSumTotal;
			for (let cost of costs) {
				res += cost.fromProjectSumTotal;
			}
			return res;
		},

		fromDocumentSum (calculateOnOldVersion = false) {
			let costs, administrativeCosts;
			if (calculateOnOldVersion) {
				costs = this.previousCostsMerged;
				administrativeCosts = this.previousAdministrativeMerged;
			} else {
				costs = this.costsMerged;
				administrativeCosts = this.administrativeMerged;
			}
			let res = 0;
			res += administrativeCosts.fromDocumentSumTotal;
			for (let cost of costs) {
				res += cost.fromDocumentSumTotal;
			}
			return res;
		},

		fromProjectSumFormatted() {
			return Numbers.methods.formatMoney(this.fromProjectSum());
		},

		fromDocumentSumFormatted() {
			return Numbers.methods.formatMoney(this.fromDocumentSum());
		},

		emptyMergedCosts(name, serialNumber, fromProject, fromDocument) {
			return {
				name: name,
				fromProject: fromProject,
				fromDocument: fromDocument,
				serialNumber: serialNumber
			};
		},


		postprocessMerged(merged) {
			merged.fromDocumentSum = 0;
			merged.fromProjectSum = 0;
			merged.fromDocument.forEach(x => merged.fromDocumentSum += x.totalPrice);
			merged.fromProject.forEach(x => merged.fromProjectSum += x.totalPrice);
		},

		postprocessCosts(costsMerged) {
			costsMerged.fromDocumentSumTotal = 0;
			costsMerged.fromProjectSumTotal = 0;
			costsMerged.costs.forEach(x => costsMerged.fromDocumentSumTotal += x.fromDocumentSum);
			costsMerged.costs.forEach(x => costsMerged.fromProjectSumTotal += x.fromProjectSum);
		},

		mergedActionCosts(actionCosts) {
			let result = [];
			for (let cost of actionCosts) {
				let costProcessed = this.emptyMergedCosts(cost.name, cost.serialNumber, cost.costDivisions, []);
				result.push(costProcessed);
			}
			return result;
		},

		costsMergedSingleAction(action) {
			let serialNumber = action.serialNumber;
			let actionCosts = action.costs;
			let mergedCosts = this.mergedActionCosts(actionCosts);

			for (let invoice of this.invoicesData) {
				let invoiceCosts = invoice.actions;
				for (let invoiceAction of invoiceCosts.filter(x => x.serialNumber === serialNumber)) {
					for (let invoiceCost of invoiceAction.costs) {
						let foundMerged = mergedCosts.find(x => x.serialNumber === invoiceCost.serialNumber);
						if (foundMerged === undefined) {
							mergedCosts.push(this.emptyMergedCosts(invoiceCost.name, invoiceCost.serialNumber, [], invoiceCost.costDivisions));
						} else {
							if (invoiceCost.name) {
								foundMerged.name = invoiceCost.name;
							}
							foundMerged.fromDocument = foundMerged.fromDocument.concat(invoiceCost.costDivisions);
						}
					}
				}
			}

			for (let merged of mergedCosts) {
				this.postprocessMerged(merged);
			}

			return mergedCosts;
		},

		costsMergedAdministrative() {
			let administrative = this.projectData.administrative;
			let mergedCosts = this.mergedActionCosts(administrative);

			for (let invoice of this.invoicesData) {
				let administrativeCosts = invoice.administrative;
				for (let invoiceCost of administrativeCosts) {

					let foundMerged = mergedCosts.find(x => x.name === invoiceCost.name);
					if (foundMerged === undefined) {
						mergedCosts.push(this.emptyMergedCosts(invoiceCost.name, invoiceCost.serialNumber, [], invoiceCost.costDivisions));
					} else {
						foundMerged.fromDocument = foundMerged.fromDocument.concat(invoiceCost.costDivisions);
					}

				}
			}

			for (let merged of mergedCosts) {
				this.postprocessMerged(merged);
			}

			return mergedCosts;
		},

		formattedSumOfCostsFromTypesFromDocument (types, omitMode, calculateOnOldVersion = false) {
			if (!this.dataLoaded) {
				return 0;
			}
			return Numbers.methods.formatMoney(this.sumOfCostsFromTypesFromDocument(types, omitMode, calculateOnOldVersion));
		},

		formattedSumOfCostsFromTypesFromProject (types, omitMode, calculateOnOldVersion = false) {
			if (!this.dataLoaded) {
				return 0;
			}
			return Numbers.methods.formatMoney(this.sumOfCostsFromTypesFromProject(types, omitMode, calculateOnOldVersion));
		},

		fromDocumentGetter() {
			return ((x) => x.fromDocument);
		},

		fromProjectGetter() {
			return ((x) => x.fromProject);
		},

		fromDotationFromProject(cost) {
			return this.sumOfCostsFromTypesSingleCost(cost, [FundingTypes.DOTATION], this.fromProjectGetter());
		},

		fromDotationFromDocument(cost) {
			return this.sumOfCostsFromTypesSingleCost(cost, [FundingTypes.DOTATION], this.fromDocumentGetter());
		},

		fromOtherFromProject(cost) {
			return this.sumOfCostsFromTypesSingleCost(cost, [FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE], this.fromProjectGetter());
		},

		fromOtherFromDocument(cost) {
			return this.sumOfCostsFromTypesSingleCost(cost, [FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE], this.fromDocumentGetter());
		},

		fromOwnHumanFromProject(cost) {
			return this.sumOfCostsFromTypesSingleCost(cost, [FundingTypes.OWN_HUMAN_CONTRIBUTION], this.fromProjectGetter());
		},

		fromOwnHumanFromDocument(cost) {
			return this.sumOfCostsFromTypesSingleCost(cost, [FundingTypes.OWN_HUMAN_CONTRIBUTION], this.fromDocumentGetter());
		},

		fromOwnInKindFromProject(cost) {
			return this.sumOfCostsFromTypesSingleCost(cost, [FundingTypes.OWN_CONTRIBUTION_IN_KIND], this.fromProjectGetter());
		},

		fromOwnInKindFromDocument(cost) {
			return this.sumOfCostsFromTypesSingleCost(cost, [FundingTypes.OWN_CONTRIBUTION_IN_KIND], this.fromDocumentGetter());
		},

		fromInterestsFromDocument(cost) {
			return this.sumOfCostsFromTypesSingleCost(cost, [FundingTypes.INTEREST, FundingTypes.INCOME], this.fromDocumentGetter());
		},

		sumOfCostsFromTypesFromSingleAction(action, costSumFromSourceCalculatorFunction) {
			let result = 0;
			for (let cost of action.costs) {
				result += costSumFromSourceCalculatorFunction(cost);
			}
			return result;
		},

		sumOfCostsFromTypesSingleCost(cost, types, costDivisionsGetter) {
			let result = 0;
			for (let division of costDivisionsGetter(cost)) {
				if (types.find(y => y === division.type || y === FundingTypes.ALL)) {
					result += division.totalPrice;
				}
			}
			return result;
		},

		sumOfCostsFromTypes (types, costDivisionsGetter, omitMode, calculateOnOldVersion = false) {
			let costs, administrativeCosts;
			if (calculateOnOldVersion) {
				costs = this.previousCostsMerged;
				administrativeCosts = this.previousAdministrativeMerged;
			} else {
				costs = this.costsMerged;
				administrativeCosts = this.administrativeMerged;
			}
			let result = 0;

			if (omitMode !== OmitModes.omitActions) {
				for (let action of costs) {
					for (let cost of action.costs) {
						result += this.sumOfCostsFromTypesSingleCost(cost, types, costDivisionsGetter);
					}
				}
			}

			if (omitMode !== OmitModes.omitAdministrative) {
				for (let cost of administrativeCosts.costs) {
					result += this.sumOfCostsFromTypesSingleCost(cost, types, costDivisionsGetter);
				}
			}


			return result;
		},

		sumOfCostsFromTypesFromDocument (types, omitMode, calculateOnOldVersion = false) {
			return this.sumOfCostsFromTypes(types, ((x) => x.fromDocument), omitMode, calculateOnOldVersion);
		},

		sumOfCostsFromTypesFromProject (types, omitMode, calculateOnOldVersion = false) {
			return this.sumOfCostsFromTypes(types, ((x) => x.fromProject), omitMode, calculateOnOldVersion);
		}
	}
};